import ArtificialIntelligence from '../../assets/artificial-intelligence-collection.svg';
import AtlassianRovo from '../../assets/atlassian-rovo-collection.svg';
import ProjectManagement from '../../assets/project-management.svg';
import SoftwareDevelopment from '../../assets/software-development.svg';
export const collections = [{
  title: 'Artificial intelligence',
  description: 'Elevate productivity with AI-powered apps to revolutionize your workflows.',
  image: ArtificialIntelligence,
  redirectUrl: '/collections/artificial-intelligence'
}, {
  title: 'Atlassian Rovo',
  description: 'Dive into an innovative app experience with apps enhanced by Rovo Agents.',
  image: AtlassianRovo,
  redirectUrl: '/collections/atlassian-rovo'
}, {
  title: 'Project Management',
  description: 'Streamline, manage, and track project phases.',
  image: ProjectManagement,
  redirectUrl: '/categories/project-management'
}, {
  title: 'Software Development',
  description: 'Code, collaborate, and plan across every stage of the DevOps cycle.',
  image: SoftwareDevelopment,
  redirectUrl: '/categories/software-development'
}];